import React from 'react';
import { Col, Button } from 'reactstrap';
import { injectIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { TRACKING_OPTIONS_PLATFORMS } from "../../../../../config/constants/Campaign/campaign_constants";

function AddTrackingComponent(props) {
  const { tracking, setTracking, initialValues, setInitialValues } = props;

  return (tracking < TRACKING_OPTIONS_PLATFORMS.length ?
    <Col xs={ 6 } sm={ 6 } className="justify-content-end">
      <Button
        className="btn-icon-only rounded-circle"
        color="info"
        type="button"
        style={ { marginTop: "27px" } }
        onClick={
          e => {
            e.preventDefault();
            setTracking(tracking + 1);
            setInitialValues({
              ...initialValues,
              tracking: [
                ...initialValues.tracking,
                {
                  tracking_name: TRACKING_OPTIONS_PLATFORMS[0].value,
                  tracking_id: '',
                }
              ]
            });
          }
        }
      >
        <FontAwesomeIcon icon={ faPlusCircle }/>
      </Button>
    </Col> : null);
}

const AddTracking = injectIntl(AddTrackingComponent)

export { AddTracking, AddTrackingComponent }
